"use client";

import { forwardRef, useMemo, useState } from "react";
import Image from "next/image";

/**
 * Custom Image extends Next JS' built-in Image component
 * @param {import("next/image").ImageProps & { className?: string, onLoadedCallback?: function }} props
 * @param {import("react").ForwardedRef<HTMLImageElement>} ref
 * @returns {import("react").JSX.Element} Rendered Image component
 */
function CustomImage({
  loading = 'lazy',
  sizes = '100vw',
  className = undefined,
  onLoadedCallback = undefined,
  alt = "",
  ...rest},
  ref
) {
  const [loaded, setLoaded] = useState(false);

  const containerClass = useMemo(() => {
    let tempClassName = 'custom-image';

    if (className) {
      tempClassName = `${tempClassName} ${className}`;
    }

    if (loaded) {
      tempClassName = `${tempClassName} custom-image--loaded`;
    }

    return tempClassName;
  }, [loaded, className]);

  return (
    <Image
      ref={ref}
      className={containerClass}
      loading={!rest.priority ? loading : 'eager'}
      sizes={sizes}
      alt={alt}
      onLoad={(e) => {
        setLoaded(true);
        onLoadedCallback && onLoadedCallback(e);
      }}
      {...rest}
    />
  );
}

export default forwardRef(CustomImage);